import React, { useEffect, useState } from 'react'
import { Element } from 'react-scroll'
import { useLocation, useSearchParams } from 'react-router-dom'
import InputField from '../InputField'
import SelectField from '../SelectField'
import ErrorMessage from '../ErrorMessage'
import UseForm from '../form/UseForm'
import { useIntl } from 'react-intl'
import SecurityBanner from '../layout/SecurityBanner'
import { OFFICE_LIST_URL, NAME_MAX_LENGTH } from '../../utils/Constants'
import { Scrollbar } from 'react-scrollbars-custom'
// import cdpcheckani01 from '../../assets/images/cdp_check_ani_01.gif'
// import cdpcheckani02 from '../../assets/images/cdp_check_ani_02.gif'
// import cdpcheckani03 from '../../assets/images/cdp_check_ani_03.gif'
// import cdpcheckani04 from '../../assets/images/cdp_check_ani_04.gif'
// import cdpcheckani05 from '../../assets/images/cdp_check_ani_05.gif'
// import cdpvoiceimg01 from '../../assets/images/cdp_voice_img_01.png'
// import cdpvoiceimg02 from '../../assets/images/cdp_voice_img_02.png'
// import cdpvoiceimg03 from '../../assets/images/cdp_voice_img_03.png'
// import cdpvoiceimg04 from '../../assets/images/cdp_voice_img_04.png'
// import outlineico01 from '../../assets/images/cdp_outline_ico_01.png'
// import outlineico02 from '../../assets/images/cdp_outline_ico_02.png'
// import outlineico03 from '../../assets/images/cdp_outline_ico_03.png'
// import outlineico04 from '../../assets/images/cdp_outline_ico_04.png'

const CDPRequestForm = () => {
    const { values, handleChange, handleSubmit, handleOnLoad, handleBlur, errors } = UseForm()
    const location = useLocation()
    const [prevValues, setPrevValues] = useState(location.state ? location.state.formData : {})
    const [isBack, setIsBack] = useState(location.state ? location.state.isBack : false)
    const intl = useIntl()
    const [queryParam] = useSearchParams()
    const from = queryParam.get('from')
    useEffect(() => {
        document.title = 'CDPエントリー｜コンサルタント社員採用｜メットライフ生命'
        if (isBack && prevValues && Object.keys(prevValues).length !== 0) {
            handleOnLoad(prevValues, from)
            if (prevValues.noContractDate === '0') {
                document.getElementById('noContractDate').checked = true
            }
            if (prevValues.policyUnknown === '0') {
                document.getElementById('policyUnknown').checked = true
            }
            setIsBack(false)
            setPrevValues({})
            location.state.isBack = false
            location.state.formData = {}
        }
        window.scrollTo(0, 0)
    }, [])

    function getInputClass (errorText) {
        return (errorText === '' || errorText === undefined) ? '' : 'error'
    }

    function getInputClass2 (value) {
        return (value === '' || value === undefined) ? 'check' : 'check_ok'
    }
    return (
        <form>
            <div id="contents">
                <div className="mainSection">
                    <Element id="entryCDP" className="entrySection">
                        <div className="sectionFrame">
                            <h2><span className="brBlock">CDPへのエントリーは</span><span className="brBlock">こちら</span></h2>
                            <p className="sectionLeadTxt">コンサルタントへの道を目指す方もこちらからエントリーください。<span className="entryPlease" style={{ fontSize: '100%' }}><br />※</span>がついている項目は必須になります。<div className="errDisplayArea" style={{ fontSize: '16px' }}><ErrorMessage errorMessage={errors.headError}></ErrorMessage></div></p>
                            <div className="formSheet">
                                <dl className="formName">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'nameTitle' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="inputTxtStyle01">
                                            <InputField
                                                type="text" name="nameKanji" value={values.nameKanji || ''}
                                                maxlength={NAME_MAX_LENGTH} title={intl.formatMessage({ id: 'kanjiNameTitle' })} data-valid="required"
                                                styleClass={`check ${getInputClass2(values.nameKanji)} ${getInputClass(errors.nameKanji)}`}
                                                attributeHandle={handleChange}
                                                attributeBlur={handleBlur}>
                                            </InputField>
                                            <div className="errDisplayArea">
                                                <ErrorMessage errorMessage={errors.nameKanji}></ErrorMessage>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                            </div>
                            <div className="formSheet">
                                <dl className="formName">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'nameTitle2' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="inputTxtStyle01">
                                            <InputField type="text" name="nameKana" value={values.nameKana || ''}
                                                maxlength={NAME_MAX_LENGTH} title={intl.formatMessage({ id: 'kanaNameTitle' })}
                                                styleClass={`check ${getInputClass2(values.nameKana)} ${getInputClass(errors.nameKana)}`} data-valid="required"
                                                attributeHandle={handleChange} attributeBlur={handleBlur} >
                                            </InputField>
                                            <div className="errDisplayArea">
                                                <ErrorMessage errorMessage={errors.nameKana}></ErrorMessage>
                                                <ErrorMessage errorMessage={errors.onlyKana}></ErrorMessage>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                            </div>
                            <div className="formSheet">
                                <dl className="formAge">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'age' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="inputTxtStyle04">
                                            <InputField
                                                type="text" name="age" value={values.age || ''}
                                                maxlength={2} title={intl.formatMessage({ id: 'age' })} data-valid="required"
                                                styleClass={`check ${getInputClass2(values.age)} ${getInputClass(errors.age)}`}
                                                attributeHandle={handleChange}
                                                attributeBlur={handleBlur}>
                                            </InputField>
                                            <div className="errDisplayArea">
                                                <ErrorMessage errorMessage={errors.age}></ErrorMessage>
                                            </div>
                                        </div>
                                    </dd><p style={{ marginTop: '5px', marginLeft: '10px' }}>歳</p>
                                </dl>
                            </div>
                            <div className="formSheet">
                                <dl className="formTelephone">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'phoneTile' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="inputTxtStyle01">
                                            <InputField type="text" name="phoneNumber" value={values.phoneNumber || ''}
                                                maxlength="11" title={intl.formatMessage({ id: 'phoneTitle' })}
                                                styleClass={`check ${getInputClass2(values.phoneNumber)} ${getInputClass(errors.phoneNumber)}`} data-valid="required"
                                                attributeHandle={handleChange} attributeBlur={handleBlur} >
                                            </InputField>
                                            <p style={{ marginTop: '5px' }}>＊ハイフン(ー)なしでご記入ください</p>
                                            <div className="errDisplayArea">
                                                <ErrorMessage errorMessage={errors.phoneNumber}></ErrorMessage>
                                                <ErrorMessage errorMessage={errors.phoneNumberInvalid}></ErrorMessage>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                            </div>
                            <div className="formSheet">
                                <dl className="formMail">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'mailId' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="inputTxtStyle02">
                                            <InputField type="text" name="mailId" value={values.mailId || ''}
                                                maxlength="120" title={intl.formatMessage({ id: 'mailIdTitle' })}
                                                styleClass={`check ${getInputClass2(values.mailId)} wMax ${getInputClass(errors.mailId)}`} data-valid="required"
                                                attributeHandle={handleChange} attributeBlur={handleBlur} >
                                            </InputField>
                                            <div className="errDisplayArea">
                                                <ErrorMessage errorMessage={errors.mailId}></ErrorMessage>
                                                <ErrorMessage errorMessage={errors.mailPattern}></ErrorMessage>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                            </div>
                            <div className="formSheet">
                                <dl className="formMailConfirm">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'confirmMailId' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="inputTxtStyle02">
                                            <InputField type="text" name="confirmMailId" value={values.confirmMailId || ''}
                                                maxlength="120" title={intl.formatMessage({ id: 'confirmMailIdTitle' })}
                                                styleClass={`check ${getInputClass2(values.confirmMailId)} wMax ${getInputClass(errors.confirmMailId)}`} data-valid="required"
                                                attributeHandle={handleChange} attributeBlur={handleBlur} >
                                            </InputField>
                                            <p className="formMsg02">{intl.formatMessage({ id: 'confirmMailIdMsg' })}</p>

                                            <div className="errDisplayArea">
                                                <ErrorMessage errorMessage={errors.confirmMailId}></ErrorMessage>
                                                <ErrorMessage errorMessage={errors.checkMailId}></ErrorMessage>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                            </div>

                            <div className="formSheet">
                                <dl className="formAcademicBg">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'finalEduBkgTitle' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="selectStyle03 selectBg">
                                            <label htmlFor="formAcademicBg" >
                                                <SelectField attributeHandle={handleChange} attributeBlur={handleBlur}
                                                    selectedValue={values.finalEduBgTypes}
                                                    styleClass={`selectGroup ${getInputClass(errors.finalEduBgTypes)}`}
                                                    dropDownName="finalEduBgTypes" fieldLabel=''></SelectField>
                                            </label>
                                        </div>
                                        <div>
                                            <p className="formMsg02">{intl.formatMessage({ id: 'formMsg02' })}</p>
                                        </div>
                                        <div className="errDisplayArea">
                                            <ErrorMessage errorMessage={errors.finalEduBgTypes}></ErrorMessage>
                                        </div>
                                    </dd>
                                </dl>
                            </div>

                            <div className="formSheet">
                                <dl className="formWorkExperience">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'workExperienceTitle' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="selectStyle03 selectBg">
                                            <label htmlFor="formWorkExperience">
                                                <SelectField attributeHandle={handleChange} attributeBlur={handleBlur}
                                                    selectedValue={values.workExperienceTypes}
                                                    styleClass={`selectGroup ${getInputClass(errors.workExperienceTypes)}`}
                                                    dropDownName="workExperienceTypes" fieldLabel=''></SelectField>
                                            </label>
                                        </div>
                                        <div>
                                            <p className="formMsg02">{intl.formatMessage({ id: 'formMsg02' })}</p>
                                        </div>
                                        <div className="errDisplayArea">
                                            <ErrorMessage errorMessage={errors.workExperienceTypes}></ErrorMessage>
                                        </div>
                                    </dd>
                                </dl>
                            </div>

                            <div className="formSheet">
                                <dl className="formChangeOccupation">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'changeOccupationTitle' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="selectStyle03 selectBg">
                                            <label htmlFor="formChangeOccupation">
                                                <SelectField attributeHandle={handleChange} attributeBlur={handleBlur}
                                                    selectedValue={values.changeOccupationTypes}
                                                    styleClass={`selectGroup ${getInputClass(errors.changeOccupationTypes)}`}
                                                    dropDownName="changeOccupationTypes" fieldLabel=''></SelectField>
                                            </label>
                                        </div>
                                        <div>
                                            <p className="formMsg02">{intl.formatMessage({ id: 'formMsg02' })}</p>
                                        </div>
                                        <div className="errDisplayArea">
                                            <ErrorMessage errorMessage={errors.changeOccupationTypes}></ErrorMessage>
                                        </div>
                                    </dd>
                                </dl>
                            </div>

                            <div className="formSheet">
                                <dl className="formChangeOccupation">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'nowOccupationTitle' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="selectStyle03 selectBg">
                                            <label htmlFor="formChangeOccupation">
                                                <SelectField attributeHandle={handleChange} attributeBlur={handleBlur}
                                                    selectedValue={values.nowOccupationTypes}
                                                    styleClass={`selectGroup ${getInputClass(errors.nowOccupationTypes)}`}
                                                    dropDownName="nowOccupationTypes" fieldLabel=''></SelectField>
                                            </label>
                                        </div>
                                        <div>
                                            <p className="formMsg02">{intl.formatMessage({ id: 'formMsg02' })}</p>
                                        </div>
                                        <div className="errDisplayArea">
                                            <ErrorMessage errorMessage={errors.nowOccupationTypes}></ErrorMessage>
                                        </div>
                                    </dd>
                                </dl>
                            </div>

                            <div className="formSheet">
                                <dl className="formWhereComeFrom">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'whereComeFromTitle' })}<span className="entryPlease"></span></div></dt>
                                    <dd>
                                        <ul className="checkGroup clearfix" style={{ listStyle: 'none' }}>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom01 !== undefined} value="他のWebサイトから" id="whereFrom01" /><label htmlFor="whereFrom01"><span className="checkBtn">他のWebサイトから</span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom02 !== undefined} value="その他検索エンジン" id="whereFrom02" /><label htmlFor="whereFrom02"><span className="checkBtn">その他検索エンジン</span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom03 !== undefined} value="テレビCM" id="whereFrom03" /><label htmlFor="whereFrom03"><span className="checkBtn">テレビCM</span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom04 !== undefined} value="新聞" id="whereFrom04" /><label htmlFor="whereFrom04"><span className="checkBtn">新聞</span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom05 !== undefined} value="雑誌" id="whereFrom05" /><label htmlFor="whereFrom05"><span className="checkBtn">雑誌</span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom06 !== undefined} value="ラジオ" id="whereFrom06" /><label htmlFor="whereFrom06"><span className="checkBtn">ラジオ</span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom07 !== undefined} value="当社営業所管長から" id="whereFrom07" /><label htmlFor="whereFrom07"><span className="checkBtn">当社営業所管長から<span className="checkStar">＊</span></span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom08 !== undefined} value="当社営業担当者から" id="whereFrom08" /><label htmlFor="whereFrom08"><span className="checkBtn">当社営業担当者から<span className="checkStar">＊</span></span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom09 !== undefined} value="その他当社社員から" id="whereFrom09" /><label htmlFor="whereFrom09"><span className="checkBtn">その他当社社員から<span className="checkStar">＊</span></span></label></li>
                                            <li><input type="checkbox" onChange={handleChange} checked={values.whereFrom10 !== undefined} value="友人・知人から" id="whereFrom10" /><label htmlFor="whereFrom10"><span className="checkBtn">友人・知人から</span></label></li>
                                        </ul>
                                        <p className="formMsg03"><span className="checkStar">＊</span>をお選びの方は、よろしければその方のお名前をご記入ください</p>
                                        <div className="checkMemo">
                                            <p className="formMsg01">{intl.formatMessage({ id: 'nameTitle' })}</p>
                                            <InputField type="text" name="acquaintanceName" value={values.acquaintanceName || ''}
                                                maxlength="15" styleClass={`${getInputClass2(values.acquaintanceName)}`}
                                                attributeHandle={handleChange} attributeBlur={handleBlur} >
                                            </InputField>
                                        </div>
                                    </dd>
                                </dl>
                            </div>

                            <div className="formSheet">
                                <dl className="formWhereCDP">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'whereCDPTitle' })}<span className="entryPlease">※</span></div></dt>
                                    <dd>
                                        <div className="whereCDPMemo">
                                            <p className="formMsg01">{intl.formatMessage({ id: 'whereCDPMemo1' })}</p>

                                            <div className="selectStyle03 selectBg">
                                                <label htmlFor="changeOccupationTimes">
                                                    <SelectField attributeHandle={handleChange} attributeBlur={handleBlur}
                                                        selectedValue={values.whereCDPMemoTypes1}
                                                        styleClass={`selectGroup ${getInputClass(errors.whereCDPMemoTypes1)}`}
                                                        dropDownName="whereCDPMemoTypes1" fieldLabel=''></SelectField>
                                                </label>
                                            </div>
                                            <span className="officeBtn"><a href={OFFICE_LIST_URL} rel="noreferrer" target="_blank" className="iconLinkArrow_R">{intl.formatMessage({ id: 'officeLink' })}&nbsp;</a></span>
                                        </div>
                                        <div className="errDisplayArea">
                                            <ErrorMessage errorMessage={errors.whereCDPMemoTypes1}></ErrorMessage>
                                        </div>

                                        <div className="whereCDPMemo">
                                            <p className="formMsg01">{intl.formatMessage({ id: 'whereCDPMemo2' })}</p>

                                            <div className="selectStyle03 selectBg">
                                                <label htmlFor="changeOccupationTimes">
                                                    <SelectField attributeHandle={handleChange} attributeBlur={handleBlur}
                                                        selectedValue={values.whereCDPMemoTypes2}
                                                        styleClass={`selectGroup ${getInputClass(errors.whereCDPMemoTypes2)}`}
                                                        dropDownName="whereCDPMemoTypes2" fieldLabel=''></SelectField>
                                                </label>
                                            </div>
                                            <div className="errDisplayArea">
                                                <ErrorMessage errorMessage={errors.whereCDPMemoTypes2}></ErrorMessage>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                            </div>
                            <div className="formSheet">
                                <dl className="formPrivacyPolicy">
                                    <dt><div className="dtWrap"><div className="formIcon"></div>{intl.formatMessage({ id: 'Header' })}</div></dt>
                                    <dd>
                                        <p className="privacyPolicyLeadTxt">{intl.formatMessage({ id: 'LeadTxt' })}</p>

                                        <div className="privacyPolicyDetail">
                                            <Scrollbar scrollTop="undefined">
                                                <div className="privacyPolicyBox">
                                                    <p className="privacyPolicyTitle">{intl.formatMessage({ id: 'privacyPolicyTitle1' })}</p>
                                                    <p className="privacyPolicyTxt">{intl.formatMessage({ id: 'privacyPolicyTxt1' })}</p>
                                                </div>
                                                <div className="privacyPolicyBox">
                                                    <p className="privacyPolicyTitle">{intl.formatMessage({ id: 'privacyPolicyTitle2' })}</p>
                                                    <p className="privacyPolicyTxt">{intl.formatMessage({ id: 'privacyPolicyTxt2' })}</p>
                                                    <ul>
                                                        <li>{intl.formatMessage({ id: 'subTxt1' })}</li>
                                                        <li>{intl.formatMessage({ id: 'subTxt2' })}</li>
                                                        <li>{intl.formatMessage({ id: 'subTxt3' })}</li>
                                                        <li>{intl.formatMessage({ id: 'subTxt4' })}</li>
                                                    </ul>
                                                </div>
                                                <div className="privacyPolicyBox">
                                                    <p className="privacyPolicyTitle">{intl.formatMessage({ id: 'privacyPolicyTitle3' })}</p>
                                                    <p className="privacyPolicyTxt">{intl.formatMessage({ id: 'privacyPolicyTxt3' })}<a href="/about/governance/privacy-policy/group/">こちら</a>をご確認ください。</p>
                                                </div>
                                                <div className="privacyPolicyBox">
                                                    <p className="privacyPolicyTitle">{intl.formatMessage({ id: 'privacyPolicyTitle4' })}</p>
                                                    <p className="privacyPolicyTxt">{intl.formatMessage({ id: 'privacyPolicyTxt4' })}</p>
                                                </div>
                                                <div className="privacyPolicyBox">
                                                    <p className="privacyPolicyTitle">{intl.formatMessage({ id: 'privacyPolicyTitle5' })}</p>
                                                    <p className="privacyPolicyTxt">{intl.formatMessage({ id: 'privacyPolicyTxt5' })}</p>
                                                </div>
                                                <div className="privacyPolicyBox">
                                                    <p className="privacyPolicyTitle">{intl.formatMessage({ id: 'privacyPolicyTitle6' })}</p>
                                                    <p className="privacyPolicyTxt">{intl.formatMessage({ id: 'privacyPolicyTxt6' })}</p>
                                                </div>
                                                <div className="privacyPolicyBox">
                                                    <p className="privacyPolicyTitle">【お問い合わせ先】</p>
                                                    <p className="privacyPolicyTxt">メットライフ生命保険株式会社
                                                        <br />エイジェンシー部門　エイジェンシー戦略統括部
                                                        <br />エイジェンシー採用育成部
                                                        <br /><a href="mailto:MetLifeCT@metlife.co.jp">MetLifeCT@metlife.co.jp</a>
                                                        <br />電子メールによりご連絡を頂いた場合、ご回答が翌営業日となる場合や、お電話などによりご本人様の確認をさせていただく場合があります。あらかじめご了承ください。</p>
                                                </div>
                                            </Scrollbar>
                                        </div>

                                    </dd>
                                </dl>
                            </div>
                            <div className="formSheet">
                                <SecurityBanner />
                                <p className="acceptAboveMsg">{intl.formatMessage({ id: 'acceptAboveMsg1' })}<br />{intl.formatMessage({ id: 'acceptAboveMsg2' })}</p>
                                <div className='b10'>
                                    <p className='btnStyle registerBtn' >
                                        <input type="submit" id="nextButton" onClick={handleSubmit} value={intl.formatMessage({ id: 'nextBtn' })} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Element>
                </div>
                <div className="pageup">
                    <p><a href="#PAGETOP"></a></p>
                </div>
            </div>
        </form>
    )
}

export default CDPRequestForm
